import { useI18n } from "../../i18n/I18nContext";

function ContactInfo({ imgPath, Title, text = [], children }) {
  const { t } = useI18n();

  return (
    <>
      <div className='single-contact-info'>
        {/* Slicica */}
        <div className='contact-img-wrapper'>
          <img src={imgPath} alt={t('alt.contactIcon')} />
        </div>
        <div className='text-description'>
          <h5>{Title}</h5>
          {children
            ? children
            : text.map((element, index) => {
                return <p key={index}>{element}</p>
              })}
        </div>
      </div>
    </>
  )
}

export default ContactInfo
